export const LABELS = {
    /**Titles */
    Os:"Os",
    ScriptManagmentTitle: "Deployment Script Management",
    Contract:"Contracts",
    CloudEnviroment:"Cloud Environment",
    CloudInitManagment:"Vm Configuration Management",
    Environment:"Environment",
    VmConfiguration:"Vm Configuration",
    CloudInit:"Cloud Init",
    PostProviosing:"Post Provisioning",
    AddPost:"Add Posts",
    Commands:"Commands",
    Policies:"Policies",
    Flavor:"Flavor",
    ProviderType:"Provider Type",
    AddPolicies:"Add Policies",
    Rules:"Rules",
    VMTemplate:"VM Template ",
    DecommissionManagment:"Decommission Management",
    CloudManagment:"Cloud Management",
    CloudEnviromentManagment:"Cloud Environment Management",
    CloudProvisioner:"Cloud Provisioner Template",
    AddCloudProvisioner:" Add Cloud Provisioner Template",
    VMTemplateManagment:"VM Template Management",
    ScriptManagmentTitleTabs: "script management tabs",
    DeploymentScriptIDTitle: "DeploymentScriptID",
    ActiveScripts: "Active Scripts",
    InactiveScripts: "Inactive Scripts",
    ConfigFiles:"Config File",
    AddConfig:"Add Config File",
    ConfigFilesList:"Config File List",
    Provider: "Provider",
    Title: "Title",
    Script: "Script",
    Location: "Location",
    DateAdded: "Date Added",
    ProvisioningDate:"Provisioning Date",
    DecommisioningDate:"Decommissioning Date",
    Notes: "Notes",
    Actions: "Actions",
    NoData:"No data Available",
    Nº: "Nº",
    DeploymentScriptID: "deploymentScriptID",
    DataCenterDescription:"DataCenter Description",
    Name:"Name",
    NameRequired:"Name is Required",
    DataCenterName:"DataCenter Name",
    DataCenterRequired:"DataCenter Name is Required",
    LocationRequired:"Location is Required",
    DeploymentScript:" Deployment Scripts",
    CloudProvider: "cloudProvider",
    CloudProviderWithSpace:"Cloud Provider",
    CloudProvisionerWithSpace:"Add Cloud Provisioner Template",
    ContractID:"Contract",
    Iac:"Iac",
    AuthenticationconfigRequired:"Authentication Config is required",
    IacRequired: "Iac is Required",
    Id: "id",
    ASC: "asc",
    Desc: "desc",
    ArrowUp: "▲",
    ArrowDown: "▼",
    NoScriptAvailable: "scripts available.",
    NO: "NO",
    Active: "Active",
    Inactive: "Inactive",
    Add: "Add",
    AddCloud:"Add Cloud",
    Status: "Status",
    Description: "Description",
    DatacenterScription:"Datacenter Description",
    EditScript: "Edit Script",
    AddScript: "Add Script",
    AddProvider: "Add Provider",
    AuthenConfig:"Authentication Config",
    JsonAlreadyExits:"JSON already exists – enter new JSON to replace it, or leave blank",
    InvalidJsonFormat: "Invalid JSON format",
    EnterValidJsonFormat:"Enter valid JSON here",
    AddCloudEnvironment: "Add Cloud Environment",
    CloudEnvironment: "Cloud Environment",
    VmTemplate: "VM Template",
     AddVmTemplate: "Add VMTemplate",
    Update: "Update",
    Save: "Save",
    Submit:"Submit",
    DragDropFileHereOrClickHere: "Drag and drop a file here,",
    OrClickHere:"or click to select file",
    DropFileHere: "Drop the files here ...",
    LogOut: "Logout",
    Profile: "Profile",
    Confirm: "Confirm",
    Cancel: "Cancel",
    Label: "label",
    Settings: "Settings",
    Sim:"sim",
    Nao:"Não",
    DetailView:"Detail View",
    Search:"Search",
    Filters:"Filters",
    ClearAll:"Clear ALL",
    ScriptIdDonotExist:"Script item ID does not exist",
    TitleDecommission:"Decommission Process.",
    Decommision:"Decommission",
    ResourcesDecommission:"Resources for Decommissioning",
    /*Required*/
    ScriptRequired:"Script",
    IacFile:"IaC File",
    NoTemplatesAvailable:"No Templates Available ",
    ProvisioningTemplate:"Provisioning Template",
    VmProvisioning:"Vm Post Provisioning",
    VmPolicy:"Vm Policy",
    SelectOs:"Select OS",
    CpuCore:"Cpu Core",
    CpuCoreValue:"Value",
    Ram:"Ram",
    RamValue:"Value:MB",
    Storage:"Storage",
    StorageValue:"Value:GB",
    Ovh:"ovh",
    NoDataAvailable:"There are no Data available to show",
    DeleteVmTemplate:"Delete Vm Template",
    TemplateDoesNotExist: "Template does not exist",
    DeletingVmTemplate:"Deleting VmTemplate",
     CopyVmTemplate:"Copying VmTemplate",
    CopyScript:"Copying Script",
    ItemsPerPage:"Items per Page",
    Showing:"Showing",
    Of:"of",
    Empty:"N/A",
   
}